module.exports = __webpack_public_path__ + "fonts/iconfont.551bea7e.ttf";